import React from 'react';
import styles from './ScrollableContainer.module.scss';

export interface ScrollableContainerViewProps {
  children: React.ReactNode;
  maxHeight?: string;
  className?: string;
}

export default function ScrollableContainerView({
  children,
  maxHeight = '400px',
  className = ''
}: ScrollableContainerViewProps) {
  return (
    <div 
      className={`${styles.scrollableContainer} ${className}`}
      style={{ maxHeight }}
    >
      {children}
    </div>
  );
}
